
import { StaticAdList } from '@components/lists/AdList'
import Link from 'next/link'
import Hr from '@components/display/Hr'
import useT from '@hooks/useTranslation'
import CATEGORY from '@constants/categories'

const Similar = ({ linkBase, offer, offers, ListItem }) => {
    const { make, model } = offer
    const makeModelBased = Boolean(make && !offer.type === 'accessory_ad')
    const heading = makeModelBased
        ? `${make} ${model}`
        : `${useT('w kategorii')} ${useT(CATEGORY[offer.type])}`

    const link = makeModelBased
        ? `${linkBase}/${encodeURIComponent(make)}/${encodeURIComponent(model)}`
        : linkBase

    return (
        <div>
            <br />
            { !offer.tracking.deleted && <Hr /> }
            <br/>
            <Link href={link}><a>
                <h2>{useT('Zobacz inne ogłoszenia')} {heading}</h2>
            </a></Link>

            {
                Boolean(offers?.length) && (
                    <>
                        <br/>
                        <div style={{ display: 'grid', gap: 30 }}>
                            <StaticAdList offers={offers} ListItem={ListItem} />
                        </div>
                    </>
                )
            }
        </div>
    )
}

export default Similar